// eslint-disable-next-line import/prefer-default-export
export const formatPrice = (price, currency) => (
  new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(price)
);
